import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface IDevToolsComponentConfiguration extends CM.Component.IConfiguration {
};
import winCSS                from './DevTools-window.module.scss';
void winCSS;
export class DevToolsComponent extends CM.Component<
	DevToolsComponent,
	IDevToolsComponentConfiguration
>
{
	static count = 0;
	static keyCodeToggleActivation = 'Numpad7';
	static keyCodeEnableSelection = 'ShiftLeft';
	static server = location.origin + ':24000';
	// static override isInsertionEnabled = false;
	// private static readonly devToolsSymbol = Symbol('devTools');
	// DOM : HTMLDivElement;
	// win : Window | null = null;
	override async component_onActivationChange(event : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_onActivationChange(event);
		if (event.subType === 'enabled') {
			this.fillUI();
			STD.events.enableDebugAndStrictMode(
				this.onEventDispatch.bind(this),
				this.onEventDispatched.bind(this)
			);
		} else {

		}
	};

	isInInspectionMode = false;

	toggleInspectionMode() {
		if (this.isInInspectionMode) {
			document.body.classList.remove('inspection');
		} else {
			document.body.classList.add('inspection');
		}
		this.isInInspectionMode = !this.isInInspectionMode;
	};

	override async component_finalize() {
		await super.component_finalize();
		console.log('!!!', this, '<<<>>>', this.component_find('@:frame'));
		// (<CM.DOMComponent<any, any, any>> this.component_find('@:frame')).component_DOM.appendChild(STD.DOM.factory({
		// 	tag :  'style',
		// 	text : winCSS
		// }));
		(<Image.Component> this.component_find('@:frame.menu.selectComponent.icon')).setSrc(nodeSearchIconDataURL);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IDevToolsComponentConfiguration
	)
	{
		super(descriptor, configuration);
		if (DevToolsComponent.count++ > 0) {
			throw STD.errors.user('Only one debugger is instantiable!');
		}
		// this.winDOM = STD.DOM.factory<typeof HTMLDivElement>({
		// 	classList : [ 'win' ],
		// 	childs    : [
		// 		{
		// 			tag  : 'style',
		// 			text : winCSS
		// 		}, {
		// 			tag        : 'link',
		// 			attributes : {
		// 				rel  : 'stylesheet',
		// 				type : 'text/css',
		// 				href : 'https://cdn.jsdelivr.net/npm/jsoneditor@9.5.7/dist/jsoneditor.min.css'
		// 			}
		// 		}, {
		// 			classList : [ 'menu' ],
		// 			childs : [
		// 				{
		// 					tag       : 'button',
		// 					classList : [ 'header-tree' ],
		// 					text      : 'Tree',
		// 					events    : { click : this.openTreeSection.bind(this) }
		// 				},
		// 				// {
		// 				// 	tag       : 'button',
		// 				// 	classList : [ 'header-configuration' ],
		// 				// 	text      : 'Configuration',
		// 				// 	events    : { click : this.openConfigurationSection.bind(this) }
		// 				// },
		// 				{
		// 					tag       : 'button',
		// 					classList : [ 'header-events' ],
		// 					text      : 'Events',
		// 					events    : { click : this.openEventsSection.bind(this) }
		// 				}, {
		// 					tag       : 'button',
		// 					classList : [ 'header-errors' ],
		// 					text      : 'Errors',
		// 					events    : { click : this.openErrorsSection.bind(this) }
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-tree'
		// 			],
		// 			childs    : [
		// 				{
		// 					classList : [ 'tree' ],
		// 					events    : { click : this.onTreeClick.bind(this) }
		// 				}, {
		// 					classList : [ 'K' ],
		// 					childs    : [
		// 						{
		// 							classList : [ 'path' ]
		// 						}, {
		// 							classList : [ 'menu' ],
		// 							childs : [
		// 								{
		// 									tag       : 'button',
		// 									classList : [ 'configuration' ],
		// 									text      : 'Configuration',
		// 									events    : {
		// 										click : this.onTreeConfigurationButtonClick.bind(this)
		// 									}
		// 								}, {
		// 									tag       : 'button',
		// 									classList : [ 'references' ],
		// 									text      : 'References',
		// 									events    : {
		// 										click : this.onTreeReferencesButtonClick.bind(this)
		// 									}
		// 								}
		// 							]
		// 						}, {
		// 							classList : [ 'sections' ],
		// 							childs    : [
		// 								{
		// 									classList : [ 'j-editor' ]
		// 								}, {
		// 									classList : [ 'references' ]
		// 								}
		// 							]
		// 						}
		// 					]
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-configuration'
		// 			],
		// 			childs : [
		// 				{
		// 					classList : [ 'j-editor' ]
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-events'
		// 			],
		// 			childs : [
		// 				{
		// 					classList : [ 'tools' ],
		// 					childs : [
		// 						{
		// 							tag    : 'button',
		// 							text   : 'x',
		// 							events : {
		// 								click : this.onEventsToolsClearClick.bind(this)
		// 							}
		// 						}
		// 					]
		// 				},
		// 				{
		// 					tag       : 'ul',
		// 					classList : [ 'list' ]
		// 				}, {
		// 					classList : [ 'details' ]
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-errors'
		// 			],
		// 			childs : [
		// 				{
		// 					classList : [ 'tools' ],
		// 					childs : [
		// 						{
		// 							tag    : 'button',
		// 							text   : 'x',
		// 							events : {
		// 								// click : this.onEventsToolsClearClick.bind(this)
		// 							}
		// 						}
		// 					]
		// 				},
		// 				{
		// 					tag       : 'ul',
		// 					classList : [ 'list' ]
		// 				}, {
		// 					classList : [ 'details' ]
		// 				}
		// 			]
		// 		}
		// 	]
		// });
		// const JE = (<any>window).JSONEditor;
		// if (JE === undefined) {
		// 	return;
		// }
		// this.treeEditor = new JE(
		// 	<HTMLDivElement>this.winDOM.querySelector('.section-tree .j-editor'),
		// 	{
		// 		onChangeJSON : STD.misc.createDebouncerPromise({
		// 			fn    : this.onComponentConfigurationChangeJSON.bind(this),
		// 			delay : 500
		// 		})
		// 	}
		// );
		// this.treeReferenceEditor = new JE(<HTMLDivElement>this.winDOM.querySelector(
		// 	'.section-tree .sections > .references'
		// ));
		// this.configurationEditor = new JE(<HTMLDivElement>this.winDOM.querySelector(
		// 	'.section-configuration .j-editor'
		// ));
		// (<any>this.winDOM.querySelector('.menu .header-tree')).click();
	};

	// private winDOM              : HTMLDivElement;
	// private currentKeyCode      : string = '';
	// private treeEditor          : any;
	// private treeReferenceEditor : any;
	// private configurationEditor : any;
	// private highlighted         : CM.DOMComponent<any, any, any> | null = null;
	// private isUsable            = false;
	private onEventDispatch(ev : STD.events.Event<any, any>) {
		if (!(ev.target instanceof CM.Component)) {
			return;
		}
		// const evsListDOM = <HTMLDivElement>this.winDOM.querySelector('.win .section-events .list');
		// const d          = new Date;
		// const dateText   = (
		// 	d.getHours()        + 'h ' +
		// 	d.getMinutes()      + 'm ' +
		// 	d.getSeconds()      + 's ' +
		// 	d.getMilliseconds() + 'ms'
		// );
		// let type = ev.type;
		// if (ev.subType) {
		// 	type += '.' + ev.subType;
		// }
		// if (type === 'message.onMouseTrackingUpdate') {
		// 	return;
		// }
		// evsListDOM.appendChild(STD.DOM.factory({
		// 	tag    : 'li',
		// 	childs : [
		// 		{
		// 			text      : type,
		// 			classList : [ 'type' ]
		// 		}, {
		// 			text      : ev.target.component_getPath(),
		// 			classList : [ 'path' ]
		// 		}, {
		// 			text      : dateText,
		// 			classList : [ 'date' ]
		// 		}
		// 	]
		// }));
	};

	private onEventDispatched(ev : STD.events.Event<any, any>) {
		void ev;
	};

	// private async onComponentConfigurationChangeJSON(newJSON : STD.object.JSONComplexRecursive) {
	// 	if (!this.highlighted) {
	// 		return;
	// 	}
	// 	const path = this.highlighted.component_getPath();
	// 	newJSON = Object.assign({}, newJSON);
	// 	console.log('>>', path, newJSON);
	// 	const response = await fetch(DevToolsComponent.server + '/saveComponentConfiguration', {
	// 		method : 'POST',
	// 		cache  : 'no-cache',
	// 		mode   : 'cors',
	// 		body   : JSON.stringify({
	// 			path,
	// 			newJSON
	// 		}),
	// 		headers : {
	// 			'Content-Type' : 'application/json'
	// 		}
	// 	});
	// 	void response;
	// 	console.log('Update saved.');
	// };
	// private onTreeClick(ev : MouseEvent) {
	// 	const t = <HTMLDivElement>ev.target;
	// 	if (!t.details || !t.details.component) {
	// 		return;
	// 	}
	// 	this.highlight(t.details.component);
	// 	this.edit();
	// };
	// private openTreeSection() {
	// 	this.winDOM.classList.remove('configuration');
	// 	this.winDOM.classList.remove('events');
	// 	this.winDOM.classList.remove('errors');
	// 	this.winDOM.classList.add('tree');
	// };
	// private openConfigurationSection() {
	// 	this.winDOM.classList.remove('tree');
	// 	this.winDOM.classList.remove('events');
	// 	this.winDOM.classList.add('configuration');
	// 	const c = this.components.reduce((a, c) => {
	// 		a[ c.getPath() ] = c.configuration;
	// 		return (a);
	// 	}, {} as Record<string, STD.object.JSON>);
	// 	this.configurationEditor.set(c);
	// };
	// private openEventsSection() {
	// 	this.winDOM.classList.remove('tree');
	// 	this.winDOM.classList.remove('configuration');
	// 	this.winDOM.classList.remove('errors');
	// 	this.winDOM.classList.add('events');
	// };
	// private async errorsRefreshList() {
	// 	const listDOM = <HTMLUListElement>this.winDOM.querySelector('.section-errors .list');
	// 	listDOM.textContent = '';
	// 	for (const error of STD.errors.getAll()) {
	// 		const infos = await STD.errors.summarize(error);
	// 		const entriesDesc = [];
	// 		for (const entry of infos) {
	// 			const header = [];
	// 			if (entry?.details?.component) {
	// 				const path = (<CM.Component<any, any>>entry?.details?.component).component_getPath();
	// 				header.push({
	// 					classList  : [ 'component' ],
	// 					text       : path,
	// 					attributes : {
	// 						title : path
	// 					}
	// 				});
	// 			}
	// 			header.push({
	// 				classList : [ 'message' ],
	// 				text : entry.message
	// 			});
	// 			entriesDesc.push({
	// 				classList : [ 'entry' ],
	// 				childs    : [
	// 					{
	// 						classList : [ 'header' ],
	// 						childs    : header
	// 					}, {
	// 						classList : [ 'stacktrace' ],
	// 						childs : [
	// 							{
	// 								text : '+'
	// 							}, {
	// 								text : entry.stacktrace.map(x => x.toString()).join('\n')
	// 							}
	// 						]
	// 					}
	// 				]
	// 			});
	// 			entriesDesc.push({
	// 				classList : [ 'separator' ]
	// 			});
	// 		}
	// 		const desc = STD.DOM.factory({
	// 			tag    : 'li',
	// 			childs : entriesDesc
	// 		});
	// 		listDOM.appendChild(desc);
	// 	}
	// };
	// private async openErrorsSection() {
	// 	this.winDOM.classList.remove('tree');
	// 	this.winDOM.classList.remove('configuration');
	// 	this.winDOM.classList.remove('events');
	// 	this.winDOM.classList.add('errors');
	// 	await this.errorsRefreshList();
	// };
	// private onEventsToolsClearClick() {
	// 	(<any>this.winDOM.querySelector('.section-events .list')).textContent = '';
	// };
	// private async onBeforeUnload() {
	// 	if (this.isStarted) {
	// 		await this.disable();
	// 	}
	// 	return (null);
	// };
	//@ts-ignore: not used
	// private async onMouseMove(ev : MouseEvent) {  //eslint-disable-line require-await
	// 	if (
	// 		!this.isUsable ||
	// 		(this.currentKeyCode !== DevToolsComponent.keyCodeEnableSelection)
	// 	) {
	// 		return;
	// 	}
	// 	let t : Element | null = ev.target as Element;
	// 	let component : CM.DOMComponent<any, any, any> | null = null;
	// 	while (t) {
	// 		const k = t as any;
	// 		if (k.details && k.details.component) {
	// 			component = k;
	// 			break;
	// 		}
	// 		t = t.parentElement;
	// 	}
	// 	<any>component;
	// 	// this.highlight((<any>component).details.component);
	// };
	// private onTreeConfigurationButtonClick(ev : MouseEvent) {
	// 	var t = ev.currentTarget;
	// 	var K = (<any>t).parentElement.parentElement;
	// 	K.classList.remove('references');
	// 	K.classList.add('configuration');
	// };
	// private onTreeReferencesButtonClick(ev : MouseEvent) {
	// 	var t = ev.currentTarget;
	// 	var K = (<any>t).parentElement.parentElement;
	// 	K.classList.remove('configuration');
	// 	K.classList.add('references');
	// };
	// private async onClick(ev : MouseEvent) {
	// 	if (this.isDisabled) {
	// 		return;
	// 	}
	// 	if (this.currentKeyCode !== DevToolsComponent.keyCodeEnableSelection) {
	// 		return;
	// 	}
	// 	ev.preventDefault();
	// 	ev.stopImmediatePropagation();
	// 	ev.stopPropagation();
	// 	this.edit();
	// };
	// private edit() {
	// 	const c = this.highlighted;
	// 	if (!c) {
	// 		this.treeEditor.set(null);
	// 		(
	// 			<HTMLDivElement>this.winDOM.querySelector('.section-tree > .K > .path')
	// 		).textContent = '';
	// 		return;
	// 	}
	// 	(
	// 		<HTMLDivElement>this.winDOM.querySelector('.section-tree > .K > .path')
	// 	).textContent = c.component_getPath();
	// 	const md = <any>c[ DevToolsComponent.devToolsSymbol ];
	// 	const refs = md.referencedBy;
	// 	this.treeEditor.set(c.component_configuration);
	// 	this.treeReferenceEditor.set(refs);
	// };
	// private highlight(component : CM.DOMComponent<any, any, any> | null) {
	// 	if (this.highlighted) {
	// 		const md = this.highlighted[ DevToolsComponent.devToolsSymbol ] as any;
	// 		md.DOM.classList.remove('highlighted');
	// 	}
	// 	this.highlighted = component;
	// 	if (this.highlighted) {
	// 		const md = this.highlighted[ DevToolsComponent.devToolsSymbol ] as any;
	// 		md.DOM.classList.add('highlighted');
	// 		const itemDOM = md.DOM;
	// 		itemDOM.scrollIntoView();
	// 	}
	// };
	private fillUI() {
		const frame = <FramePopup.Component<any>> this.component_find('@:frame');
		const w = frame.window;
		if (!w) {
			return;
		}
		// w.document.head.appendChild(STD.DOM.factory({
		// 	tag        : 'link',
		// 	attributes : {
		// 		rel  : 'stylesheet',
		// 		type : 'text/css',
		// 		href : 'https://cdn.jsdelivr.net/npm/jsoneditor@9.5.7/dist/jsoneditor.min.css'
		// 	}
		// }));
		// w.document.body.appendChild(this.winDOM);
		// const componentsTreeDOM = <HTMLDivElement>this.winDOM.querySelector(
		// 	'.section-tree > .tree'
		// );
		// const stack : CM.Component<any, any>[]= [ CM.root ];
		// // const stack = [ ...CM.topLevels ];
		// const allComponents : CM.Component<any, any>[] = [];
		// // this.components = allComponents;
		// while (stack.length) {
		// 	const component = stack.shift() as CM.Component<any, any>;
		// 	allComponents.push(component);
		// 	const DOM = STD.DOM.factory({
		// 		classList : [ 'node' ],
		// 		childs    : [
		// 			{
		// 				classList : [ 'label' ],
		// 				text      : `${ component.id }( ${ component.static.type } )`,
		// 				details   : {
		// 					component
		// 				}
		// 			}, {
		// 				classList : [ 'childs' ]
		// 			}
		// 		]
		// 	});
		// 	if (component.parent) {
		// 		const parentMd = component.parent[ DevToolsComponent.devToolsSymbol ];
		// 		(<any>parentMd).DOM.children[1].appendChild(DOM);
		// 	} else {
		// 		componentsTreeDOM.appendChild(DOM);
		// 	}
		// 	component[ DevToolsComponent.devToolsSymbol ] = {
		// 		DOM,
		// 		referencedBy : {}
		// 	};
		// 	for (let c of component.innerChilds) {
		// 		stack.push(c);
		// 	}
		// 	for (let c of component.outerChilds) {
		// 		stack.push(c);
		// 	}
		// }
		// for (let c of allComponents) {
		// 	const conf = c.configuration as CM.IComponentConfiguration;
		// 	const evs = conf['@listen'] || [];
		// 	for (let ev of evs) {
		// 		for (let cPath of (ev.components || [ ev.component ])) {
		// 			if (!cPath) {
		// 				this.throwUserError('');
		// 			}
		// 			const target = c.find(cPath);
		// 			if (!target) {
		// 				this.throwLibraryError('err', {
		// 					cPath,
		// 					ev,
		// 					allComponents
		// 				});
		// 			}
		// 			const md: any = target[ DevToolsComponent.devToolsSymbol ];
		// 			let mdRefByC = md.referencedBy[ c.getPath() ];
		// 			if (!mdRefByC) {
		// 				mdRefByC = md.referencedBy[ c.getPath() ] = {
		// 					events : {}
		// 				};
		// 			}
		// 			const eventsNames = (
		// 				ev.event ? [ ev.subEvent ? ev.event + '.' + ev.subEvent : ev.event ] :
		// 				(
		// 					(<string[]>ev.events).map(x => (ev.subEvent ? x + '.' + ev.subEvent : x))
		// 				)
		// 			);
		// 			for (let evName of eventsNames) {
		// 				mdRefByC.events[ evName ] = ev.actions;
		// 			}
		// 		}
		// 	}
		// }
		// this.isUsable = true;
	};
};
export namespace NS {
	export const Component = DevToolsComponent;
	export type Component = DevToolsComponent;
	export type Configuration = IDevToolsComponentConfiguration;
}
;
import './DevTools.scss';
import nodeSearchIconDataURL from './icons/node_search_icon.svg';
import manifestXMLSource     from './DevTools.xml';
import { NS as FramePopup }  from '../frames/FramePopup/FramePopup';
import { NS as Image }       from '../Image/Image';

CM.declare({
	id :       'devTools',
	type :     DevToolsComponent,
	manifest : manifestXMLSource
});
